import { useTranslation } from 'react-i18next';
import ConfirmModal from 'shared/modal/ConfirmModal';

interface RouteLeavingProps {
  routeLeavingConfigs?: {
    showPrompt: boolean;
    confirmNavigation: () => void;
    cancelNavigation: () => void;
  }
}

const RouteLeaving = ({ routeLeavingConfigs }: RouteLeavingProps) => {
  const { t } = useTranslation();

  if (!routeLeavingConfigs) {
    return;
  }

  const { showPrompt, confirmNavigation, cancelNavigation } = routeLeavingConfigs;

  return <ConfirmModal visible={showPrompt} changeModalState={cancelNavigation} text={t('confirm:leavePage')} handleConfirm={confirmNavigation} />;
};

export default RouteLeaving;
